import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import { CookiesProvider } from "react-cookie";
import flagsmith from "flagsmith";
import { FlagsmithProvider } from "flagsmith/react";
import "./Localization/config";
import { Provider } from "react-redux";
import store from "./store";

ReactDOM.render(
  <CookiesProvider>
    <React.StrictMode>
      <FlagsmithProvider
        options={{
          // environmentID: "Thq5Ahfo6bzKEpMGAFYFm3", // dev
          environmentID: "UBxtY5FkL62JUdhMEWzx4e", // prod
        }}
        flagsmith={flagsmith}
      >
        <Provider store={store}>
          <App />
        </Provider>
      </FlagsmithProvider>
    </React.StrictMode>
  </CookiesProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
